import React from "react";

export default function KnowbyView() {
  return (
    <div>
        
    </div>
  );
}